module.exports = __webpack_public_path__ + "static/media/vigorous.45f4ef79.mp4";